// React
import React from 'react';

// Components
import BigHexagon from './components/Hexagon';

// Style
import './style.sass';

// Images
 const imageHex = require('assets/images/NewDesign/Home/third-section/side-hex/pentagonoBG.png');

class ThirdSection extends React.Component {
    render() {
        const { t } = this.props;

        return(
            <div className="third-section-wrapper">
              <div className="content-container" style={{background: `url(${imageHex}) no-repeat`, backgroundSize: '500px 150%', backgroundPosition: 'right center'}}>
                <div className="hex-container">
                    <BigHexagon t={t} />
                </div>
              </div>
            </div>
        );
    }
}

export default ThirdSection;